import "./ris.styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
const RIStock = ({ tempObject, deleteFunction, unitsObject }) => {
  const { itemName, dateValue, quantity, unit } = tempObject;
  return (
    <div className="ri-stock-item">
      <div className="ri-stock-item-details">
        <span className="ri-stock-item-name">{itemName}</span>
        <span className="ri-stock-date">{dateValue}</span>
        <span className="ri-stock-quantity">
          x {quantity}
          {unitsObject[unit]}
        </span>
      </div>
      <div className="ri-stock-item-delete">
        <span
          className="ri-stock-delete-button"
          onClick={() => deleteFunction(tempObject["_id"])}
        >
          <FontAwesomeIcon icon={faTrash} />
        </span>
      </div>
    </div>
  );
};
export default RIStock;
